module.exports = __webpack_public_path__ + "6df4b6b057d81cee.svg";